import React, { useContext } from "react";
import RoundedRectangle from "../RoundedRectangle";
import type { PlayerSeason } from "../../../client/api";
import { showTranslated } from "../../../config/translator";
import { ClavaContext } from "../../../config/contexts";

type SeasonStatRowProps = {
  label: string;
  value: number;
};

const SeasonStatRow: React.FC<SeasonStatRowProps> = ({ label, value }) => (
  <div className="flex items-center justify-between py-3">
    <span className="text-sm text-font-600 dark:text-font-600-dark">{label}</span>
    <span className="text-sm text-font dark:text-font-dark">{value}</span>
  </div>
);

type PlayerSeasonStatsProps = {
  seasonStats: PlayerSeason[];
};

const PlayerSeasonStats: React.FC<PlayerSeasonStatsProps> = ({ seasonStats }) => {
  const { l } = useContext(ClavaContext);

  return (
    <RoundedRectangle
      className="rounded-xl mb-4 bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark"
      hasBorder
      hasTitle
      titleType="upLeft"
      titleKey="season"
    >
      <div className="px-6 xl:px-8 py-4">
        {seasonStats.map((stat) => (
          <SeasonStatRow
            key={stat.text.textEN}
            label={showTranslated(stat.text, l)}
            value={stat.value}
          />
        ))}
      </div>
    </RoundedRectangle>
  );
};

export default PlayerSeasonStats;

